import React from 'react';

import { Box, BoxProps } from '@chakra-ui/react';

import { Container } from '../Container/Container';

export type SectionProps = BoxProps & {
	secondaryBg?: boolean;
	children: React.ReactNode;
};

export const Section = ({ secondaryBg, children, ...rest }: SectionProps) => {
	return (
		<Box as="section" py={8} bg={secondaryBg ? 'secondary.50' : undefined} {...rest}>
			<Container>{children}</Container>
		</Box>
	);
};
